<template>
	<div class="empty-state">
		<table class="empty-state-ghost">
			<thead>
				<tr>
					<th></th>
					<th></th>
					<th></th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="n in 5" :key="n">
					<td><div class="ghost-cell"></div></td>
					<td><div class="ghost-cell"></div></td>
					<td><div class="ghost-cell"></div></td>
					<td><div class="ghost-cell"></div></td>
				</tr>
			</tbody>
		</table>
		<div class="empty-state-content">
			<p class="mb-2">{{ label || $t('global.empty_state_default') }}</p>
			<slot name="action"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EmptyState',
	props: {
		label: {
			type: String,
			default: null
		}
	}
}
</script>
